import React, { useEffect, useState, FC } from 'react';
import { ComponentRendering, isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import { TProductCard, TSeriesListingProps } from './types/seriesListing.types';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ProductCard from './components/productCard';
import { SeriesListingModel } from './models/seriesListing.model';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const ProductSeriesListing: FC<TSeriesListingProps> = (props) => {
  let model = new SeriesListingModel(props);
  const apiResponse = isEmptyResponse(props);
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);

  const [items, setItems] = useState<TProductCard[] | null>(null);

  useEffect(() => {
    model = new SeriesListingModel(props); // eslint-disable-line
    setItems(model.items);
  }, [props]);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent
      rendering={props?.rendering as ComponentRendering}
      title={props?.fields?.apiData?.parentTitle ?? ''}
      template="Series Listing"
    >
      <div className="product-card-dashboard__wrapper">
        <div className="product-card-dashboard">
          <section className="product-card-dashboard__products product-card-dashboard__products--top-padding">
            {items?.map((productCard, i) => (
              <ProductCard
                {...productCard}
                bodyTextVisibility={model.bodyTextVisibility}
                bodySpecVisibility={model.bodySpecVisibility}
                baseUrl={model.baseUrl}
                key={productCard?.id}
                componentNumber={i + 1}
              />
            ))}
          </section>
        </div>
      </div>
    </AnalyticsVisibleEvent>
  );
};

export default ProductSeriesListing;
